import axios, { AxiosResponse } from 'axios';
import * as Sentry from '@sentry/react';

declare global {
	interface Window {
		ReactNativeWebView: {
			postMessage: (value: string) => void;
		};
	}
}

const apiUrl = process.env.REACT_APP_API_URL;

const postMessage = () => {
	localStorage.removeItem('token');
	if (typeof window == undefined || !window?.ReactNativeWebView) {
		return;
	} else {
		window.ReactNativeWebView?.postMessage(
			JSON.stringify({
				type: 'OVERLAP',
			})
		);
	}
};

const get = async <R extends Record<string, any>>(
	url: string,
	params?: object
): Promise<AxiosResponse<{ statusCode: number; message: string; data: R; error?: string }>> => {
	const token = localStorage.getItem('token');
	let result = null;
	try {
		result = await axios.get(apiUrl + url, {
			params: params,
			headers: { Authorization: token },
		});
	} catch (e) {
		if (e.response?.data !== undefined) {
			if (e.response?.status !== 401) {
				const { data } = e.response;
				Sentry.withScope((scope) => {
					scope.setTag('api', 'GET');
					scope.setTag('url', url);
					scope.setExtra('responseData', data);
					scope.setExtra('params', params);

					// 제목용으로 message를 강제로
					const msg =
						typeof data?.message === 'string'
							? data.message
							: Array.isArray(data?.message)
								? data.message.join(', ')
								: e.message;

					scope.setFingerprint(['api', 'GET', url, String(e.response?.status ?? '')]); // 그룹핑 안정화(선택)
					Sentry.captureException(`${e.response?.status} ${url}: ${msg}`);
				});
			}
			if (e.response.data.error == -999) {
				postMessage();
			} else {
				result = { ...e, data: e.response.data };
			}
		}
	}
	return result;
};

const post = async (url: string, params?: object) => {
	const token = localStorage.getItem('token');
	let result = null;
	try {
		result = await axios.post(apiUrl + url, params, {
			headers: { Authorization: token },
		});
	} catch (e) {
		if (e.response?.data !== undefined) {
			if (e.response.data.error == -999) {
				postMessage();
			} else {
				result = e;
			}
		}
	}
	return result;
};
const patch = async (url: string, params?: object) => {
	const token = localStorage.getItem('token');
	let result = null;
	try {
		result = await axios.patch(apiUrl + url, params, {
			headers: {
				Authorization: token,
				'Content-Type': `application/json;charset=UTF-8`,
				Accept: 'application/json',
				// 추가
				'Access-Control-Allow-Origin': [`https://api.service.go-pang.com`, 'https://service.go-pang.com'],
				'Access-Control-Allow-Credentials': true,
			},
			// headers: { Authorization: token },
			// headers: {
			// 	Authorization: token,
			// 	"Content-Type": "multipart/form-data",
			// },
		});
	} catch (e) {
		if (e.response?.data !== undefined) {
			if (e.response.data.error == -999) {
				postMessage();
			} else {
				result = e;
			}
		}
	}
	return result;
};
const del = async (url: string, params?: object) => {
	const token = localStorage.getItem('token');
	let result = null;
	try {
		result = await axios.delete(apiUrl + url, {
			headers: { Authorization: token },
		});
	} catch (e) {
		if (e.response?.data !== undefined) {
			if (e.response.data.error == -999) {
				postMessage();
			} else {
				result = e;
			}
		}
	}
	return result;
};
export default { get, post, patch, del };
